export const getSingleTestData = (payload?: any) => ({
    type: "@saga/GET_SINGLE_TEST_DATA",
    payload
});

